<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-lg-4">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col-lg-4" style="margin-top:20px;margin-bottom:20px">
            <span>{{$t('start_date')}}</span> <base-input style="padding-top: 1rem;margin-bottom: 0rem;" addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker slot-scope="{focus, blur}"
                            @on-close="blur, ChangeDate()"
                            :config="config"
                            class="form-control datepicker"
                            v-model="start_date">
                </flat-picker>
            </base-input>
        </div>
        <div class="col-lg-4" style="margin-top:20px;margin-bottom:20px">
            <span>{{$t('end_date')}}</span> <base-input style="padding-top: 1rem;margin-bottom: 0rem;" addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker slot-scope="{focus, blur}"
                            @on-close="blur, ChangeDate()"
                            :config="config"
                            class="form-control datepicker"
                            v-model="end_date">
                </flat-picker>
            </base-input>
        </div>
      </div>
    </div>

    <div class="table-responsive">

      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="show_item">
        <template slot="columns">
          <th></th>
          <th>{{$t('first_name')}} {{$t('last_name')}}</th>
          <th>{{$t('nickname')}}</th>
          <th>{{$t('phone')}}</th>
          <th>{{$t('check_in_at')}}</th>
          <!-- <th></th> -->
        </template>

        <template slot-scope="{row}">
          <td>
            <div class="media align-items-center">
                <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row.member._id" class="text-light">
                    <img v-if="row.member.photo !== ''" width="150px" :src="row.member.photo.thumbnail">
                    <img v-if="!row.member.photo" width="150px" src="/img/noimage.png">
                </router-link>
            </div>
          </td>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row.member._id" class="text-light">
                  <span style="color:#525f7f" class="name mb-0 text-sm">{{row.member.firstname}} {{row.member.lastname}}</span>
                </router-link>
              </div>
            </div>
          </th>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row.member._id" class="text-light">
              <span style="color:#525f7f">{{row.member.nickname}}</span>
            </router-link>
          </td>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row.member._id" class="text-light">
              <span style="color:#525f7f">{{row.member.phone}}</span>
            </router-link>
          </td>
          <td>
              <span style="color:#525f7f">{{ row.check_in_at | luxon }}</span>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
         <div @click="ListItem()">
            <base-pagination v-model="page" :perPage="show_page.limit" :total="show_page.total" :pageCount="show_page.total" size="lg"></base-pagination>
        </div>
    </div>

    <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>

  </div>
</template>
<script>
var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000)
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
  export default {
    name: 'history-table',
    components: { flatPicker },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        show_item: [],
        show_page: [],
        id: this.$route.query.id,
        start_date : new Date(beforeOneWeek).toISOString(),
        end_date : new Date().toISOString(),
        limit: 10,
        page: 1,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'j M, Y',
          altInput: true,
          dateFormat: 'Y-m-d'
        }
      }
    },
    computed: {
      rows() {
          return this.show_item.length
      }
    },
    created () {
      // this.ListItem(new Date(this.start_date).toISOString(), new Date(this.end_date).toISOString())
      this.ListItem()
    },
    watch: {
        '$route': function(){
          this.id = this.$route.query.id,
          setTimeout(() => {
            // this.ListItem('', '');
            this.ListItem();
          }, 100)
        }
    },
    methods: {
      modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
      },
      ChangeDate () {
        this.page = 1
          setTimeout(() => {
            // alert('ok')
            // this.ListItem(new Date(this.start_date).toISOString(), new Date(this.end_date).toISOString());
            this.ListItem();
          }, 100)
      },
      // ListItem (start, end) {
      ListItem () {
        if (this.id === undefined) {
          this.id = ''
        }
        this.show_item = []
        this.page = this.page-1
        // alert('members/checkin?member_id='+this.id+'&limit='+this.limit+'&page='+this.page+'&start_date='+start+'&end_date='+end)
        this.$http.get('members/checkin?member_id='+this.id+'&limit='+this.limit+'&page='+this.page+'&start_date='+this.start_date+'&end_date='+this.end_date)
          .then(request => this.ListItemSuccessful(request))
          .catch(() => this.ListItemFailed())
        this.page = this.page+1
      },
      ListItemSuccessful (req) {
        if (req.data.code !== '0') {
          this.ListItemFailed(req)
          return
        }
        for (var i = 0, l = req.data.data.data.length; i < l; i++) {
          this.show_item.push(req.data.data.data[i])
          if(req.data.data.data[i].member.photo === undefined) {
            this.show_item[i].member.photo = ''
          }
        }
        this.show_page = req.data.data.pagination
      },
      ListItemFailed (req) {
        this.modalAlert(req)
      }
    }
  }
</script>
<style>
</style>
